<template>
  <header class="d-flex flex-column justify-content-center w-100 text-center">
    <img src="/assets/img/header.jpeg" alt="Tornverse" class="logo" />
  </header>
</template>

<script>
export default {
  name: 'app-header',
}
</script>

<style lang="sass" scoped>
header
  background: #000

.logo
  width: 100%
  align-self: center

  @media screen and (max-width: 600px)
    min-height: 100px
    width: 100%
</style>
